"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const intl_1 = require("@kyruus/intl");
/**
 * Internationalized messages for this widget
 * These get passed through `React-Intl`
 * And should follow a format of:
 * Roses are {color_1} and violets are {color_2}
 */
exports.default = (0, intl_1.defineMessages)({
    // ========
    // ========
    // appointmentReschedule.
    // ========
    // ========
    // info.*
    // ========
    selectActionMessage: {
        id: 'appointmentReschedule.info.selectActionMessage',
        description: 'The message to display info banner on the reschedule home page.',
        defaultMessage: 'Your appointment with {provider_name} is scheduled for {appointment_time}. What would you like to do next?'
    },
    noJumpToDateResults: {
        id: 'appointmentReschedule.info.no_jump_to_date_results',
        description: 'Message used to indicate that we did not find any results at the date jumped to',
        defaultMessage: 'There are no appointments available from {date}.'
    },
    noFilteredResultsNoMoreResults: {
        id: 'appointmentReschedule.info.no_filtered_results_no_more_results',
        description: 'Message used to indicate that we did not find any results with the current filters applied and there are no more results available',
        defaultMessage: 'There are no appointments that meet your filtering criteria between {jumpedToDate} and {date}. There are no more appointments available from {date}.'
    },
    noFilteredResults: {
        id: 'appointmentReschedule.info.no_filtered_results',
        description: 'Message used to indicate that we did not find any results with the current filters applied',
        defaultMessage: 'There are no appointments that meet your filtering criteria between {jumpedToDate} and {date}.'
    },
    selectReasonAlert: {
        id: 'appointmentReschedule.info.selectReasonAlert',
        description: 'The message to display info banner on the reschedule reason selection page.',
        defaultMessage: 'Please provide a reason for changing the appointment.'
    },
    reviewAppointmentTime: {
        id: 'appointmentReschedule.info.reviewAppointmentTime',
        description: 'The message to display info banner on the reschedule reason selection page.',
        defaultMessage: 'Review your new appointment date and time.'
    },
    reschedulingFailedAlert: {
        id: 'appointmentReschedule.info.reschedulingFailedAlert',
        description: 'The message to display info banner on the reschedule reason selection page.',
        defaultMessage: "We are having trouble rescheduling your appointment. Please try again or call your provider's office."
    },
    appointmentRescheduleSuccessMessage: {
        id: 'appointmentReschedule.info.appointmentRescheduleSuccess',
        description: 'The message to display info banner on the reschedule success confirmation page',
        defaultMessage: 'Your appointment with {provider_name} has been rescheduled to {appointment_date} at {appointment_time}. You will receive a confirmation email shortly.'
    },
    appointmentUnchangedSuccessMessage: {
        id: 'appointmentReschedule.info.appointmentUnchangedSuccess',
        description: 'The message to display info banner on the appointment unchanged confirmation page',
        defaultMessage: 'Your appointment with {provider_name} is scheduled for {appointment_date} at {appointment_time}. No changes were made to your scheduled appointment.'
    },
    appointmentRescheduleSuccessMessageTitle: {
        id: 'appointmentReschedule.info.reschedulingSuccessTitle',
        description: 'The title to display for the info banner on the reschedule success confirmation page',
        defaultMessage: 'Appointment Rescheduled'
    },
    appointmentUnchangedSuccessMessageTitle: {
        id: 'appointmentReschedule.info.unchangedSuccessTitle',
        description: 'The title to display for the info banner on the reschedule unchanged success confirmation page',
        defaultMessage: 'Appointment Unchanged'
    },
    printButtonText: {
        id: 'appointmentReschedule.labels.printButtonText',
        description: 'Text for the button that lets users print their appointment details',
        defaultMessage: 'Print'
    },
    appointmentTimeMessage: {
        id: 'appointmentReschedule.info.appointmentTimeMessage',
        description: 'The message to display info on the appointment time selection page.',
        defaultMessage: 'Select a new date and time for your appointment'
    },
    // btn.*
    // ========
    cancelAppointment: {
        id: 'appointmentReschedule.btn.cancelAppointment',
        description: 'The button text to cancel the appointment.',
        defaultMessage: 'Cancel Appointment'
    },
    rescheduleAppointment: {
        id: 'appointmentReschedule.btn.rescheduleAppointment',
        description: 'The button text to reschedule the appointment.',
        defaultMessage: 'Reschedule Appointment'
    },
    keepOriginalAppointment: {
        id: 'appointmentReschedule.btn.keepOriginalAppointment',
        description: 'The button text to keep the original appointment.',
        defaultMessage: 'Keep Original Appointment'
    },
    bookAppointment: {
        id: 'appointmentReschedule.btn.bookAppointment',
        description: 'The button text to book the appointment.',
        defaultMessage: 'Book Appointment'
    },
    reasonPlaceholder: {
        id: 'appointmentReschedule.btn.reasonPlaceholder',
        description: 'The placeholder text for the reason input field.',
        defaultMessage: 'Select'
    },
    reasonLabel: {
        id: 'appointmentReschedule.btn.reasonLabel',
        description: 'The label text for the reason input field.',
        defaultMessage: 'Reason (optional)'
    },
    // Filter toolbar
    // ========
    manageAppointmentFilterBy: {
        id: 'appointmentReschedule.filter_by',
        description: 'Text for the filter label in Reschedule appointment step',
        defaultMessage: 'Filter By'
    },
    manageAppointmentCalendarPlaceholder: {
        id: 'appointmentReschedule.calendar_placeholder',
        description: 'Text for calendar placeholder',
        defaultMessage: 'Jump to a Date'
    },
    manageAppointmentFilterTimeOfDay: {
        id: 'appointmentReschedule.time_of_day',
        description: 'Text for the filter button time of day',
        defaultMessage: 'Time of Day'
    },
    manageAppointmentFilterDayOfWeek: {
        id: 'appointmentReschedule.day_of_week',
        description: 'Text for the filter button day of week',
        defaultMessage: 'Day of Week'
    },
    ariaJumpToDateFilterTimeOfDayButton: {
        id: 'aria.label.jumpToDate.filterByTimeOfDay',
        description: 'Accessibility label for jump to date filter by time of day button',
        defaultMessage: 'Filter by Time of Day'
    },
    ariaJumpToDateFilterDayOfWeekButton: {
        id: 'aria.label.jumpToDate.filterByDayOfWeek',
        description: 'Accessibility label for jump to date filter by day of week button',
        defaultMessage: 'Filter by Day of Week'
    },
    ariaProviderTimeSlotDescription: {
        id: 'aria.label.provider.timeSlot.description',
        description: 'Accessibility for provider time slot button description',
        defaultMessage: `Book appointment with {providerName} on {date} at {time}.`
    },
    ariaPrintConfirmation: {
        id: 'aria.label.printConfirmationButton',
        description: 'Accessibility label for button on appointment confirmation page that prints the appointment details',
        defaultMessage: 'Print confirmation'
    },
    ariaGoBack: {
        id: 'aria.label.goBackButton',
        description: 'Accessibility label for back button in header',
        defaultMessage: 'Go back'
    },
    appointmentId: {
        id: 'appointment_confirm.appointment_id',
        description: 'A label that indicates the booked appointment id',
        defaultMessage: 'Appointment ID: {appointmentId}'
    },
    back: {
        id: 'appointmentReschedule.btn.goBack',
        description: 'Text for the go back button in the header',
        defaultMessage: 'Back'
    },
    // Header
    // ========
    headerDateAndTime: {
        id: 'appointmentReschedule.header.dateAndTime',
        description: 'The header text for the date and time section',
        defaultMessage: 'Date & Time'
    },
    headerConfirmation: {
        id: 'appointmentReschedule.header.confirmation',
        description: 'The header text for the confirmation section',
        defaultMessage: 'Confirmation'
    },
    // error.*
    // ========
    failedToLoad: {
        id: 'appointmentReschedule.error.failedToLoad.banner',
        description: 'The banner text displayed if the API failed to load.',
        defaultMessage: "We're unable to reschedule your appointment online at this time. Please call your provider's office."
    },
    modificationWindowExpired: {
        id: 'appointmentReschedule.error.cancelationRescheduleExpired.banner',
        description: 'The banner text displayed when the cancellation and reschedule window has expired.',
        defaultMessage: "We're unable to cancel or reschedule online this close to the appointment start time. Please call your provider's office."
    },
    appointmentAlreadyRescheduled: {
        id: 'appointmentReschedule.error.appointmentAlreadyRescheduled.banner',
        description: 'The banner text displayed when the appointment has been rescheduled.',
        defaultMessage: 'This link has expired. Please use the most recent link sent to your email to modify your appointment.'
    },
    rescheduleDisabled: {
        id: 'appointmentReschedule.error.rescheduleDisabled.banner',
        description: 'The banner text displayed when cancel or reschedule actions are disabled.',
        defaultMessage: "We're unable to reschedule your appointment online at this time. Please call your provider's office."
    },
    appointmentMissed: {
        id: 'appointmentReschedule.error.appointmentMissed.banner',
        description: 'The banner text displayed when the user has missed their appointment.',
        defaultMessage: "We're unable to cancel or reschedule online at this time. Please call your provider's office."
    },
    previouslyCanceledPageHeading: {
        id: 'appointment_cancel.confirmation_page.previously_canceled_page_heading',
        description: 'Heading text for the confirmation page when the appointment was previously canceled',
        defaultMessage: 'This appointment has already been canceled. No further action is required.'
    }
});
//# sourceMappingURL=messages.js.map